var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvatar2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_690",
    "data-name": "Ellipse 690",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_298",
    "data-name": "Mask Group 298",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_686",
    "data-name": "Ellipse 686",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900",
    transform: "translate(6.683 11.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44333",
    "data-name": "Path 44333",
    d: "M2193.412,4665.449s7.76-13.063,7.5-16.246-6.426-10.458-13.648-14.3-12.752-2.967-16.589-3.824-6.157-2.618-6.158-3.753,1.583-2.055,1.729-3.759a3.886,3.886,0,0,0-2.727-4.138c-1.924-.523-4.445.073-4.967,2.045s-.087,4.125-.574,4.634-3.567-.108-5.585,1.7a6.042,6.042,0,0,0-1.906,4.394,4.673,4.673,0,0,1,5.979-3.145c4.754,1.24,5.131,6.339,5.131,6.339l.833,1.445-.833,2.42.345.5-.345,8.051,3.918,2.68Z",
    transform: "translate(-2136.025 -4619.254)",
    fill: "#21120d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44334",
    "data-name": "Path 44334",
    d: "M2162.659,4638.838c-.561.659-2.844,5.534-5.557,6.292s-4.775.186-5.92-2.865-1.038-7.923-.994-8.865-.091-3.525,4.169-4.421a6.165,6.165,0,0,1,5.652,2.393c1.356,1.9,1.729,3.575,2.046,3.7.433.172.329-.973,1.5-.49,1.153.576.525,2.21.19,3.625-.13.608-.528,1.381-1.085,1.329C2161.462,4639.428,2163.151,4638.26,2162.659,4638.838Z",
    transform: "translate(-2136.054 -4619.466)",
    fill: "#9c6433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44335",
    "data-name": "Path 44335",
    d: "M2195.9,4665.791a113.155,113.155,0,0,0-13.484-11.906,40.385,40.385,0,0,0-15.114-6.182s-3.885,4.519-6.341,4.931-3.486-3.281-3.486-3.281a59.731,59.731,0,0,0-11.147,6.7,67.044,67.044,0,0,0-9.09,9.308s13.625,15.2,27.741,15.2S2195.9,4665.791,2195.9,4665.791Z",
    transform: "translate(-2137.233 -4618.853)",
    fill: "#fddde0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44336",
    "data-name": "Path 44336",
    d: "M2155.766,4650.011l.1.41s.725,2.355,2.387,2.625,2.847-.479,4.314-1.6a15.557,15.557,0,0,0,3.06-2.946,6.905,6.905,0,0,1-2.537-3.432,33.576,33.576,0,0,1-1.236-5.906,16.734,16.734,0,0,1-2.422,3.7,7.3,7.3,0,0,1-2.886,1.839,8.635,8.635,0,0,1,.437,3.059A4.129,4.129,0,0,1,2155.766,4650.011Z",
    transform: "translate(-2135.544 -4619.626)",
    fill: "#9a6438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44337",
    "data-name": "Path 44337",
    d: "M2391.795,4688.529a12.5,12.5,0,0,1-.72,3.493,2.572,2.572,0,0,1-1.429,1.3,5.966,5.966,0,0,0,0-1.3,6.125,6.125,0,0,0-.324-1.265,3.429,3.429,0,0,0,1.33-.729A6.949,6.949,0,0,0,2391.795,4688.529Z",
    transform: "translate(-2368.179 -4665.236)",
    fill: "#89532d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_687",
    "data-name": "Ellipse 687",
    transform: "translate(14.555 15.784)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.611,
    cy: 0.611,
    rx: 0.611,
    ry: 0.611,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.611,
    cy: 0.611,
    rx: 0.111,
    ry: 0.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_688",
    "data-name": "Ellipse 688",
    transform: "translate(20.424 15.784)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.611,
    cy: 0.611,
    rx: 0.611,
    ry: 0.611,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.611,
    cy: 0.611,
    rx: 0.111,
    ry: 0.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_689",
    "data-name": "Ellipse 689",
    cx: 1.157,
    cy: 1.157,
    rx: 1.157,
    ry: 1.157,
    transform: "translate(25.88 19.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44338",
    "data-name": "Path 44338",
    d: "M5358.625,1879.478a11.273,11.273,0,0,0-1.262,2.3c.027.372,1.262.644,1.262.644Z",
    transform: "translate(-5341.12 -1862.614)",
    fill: "#89532d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44339",
    "data-name": "Path 44339",
    d: "M5357.664,1886.417l4.282-.086s-.688,2.335-2.329,2.259S5357.664,1886.417,5357.664,1886.417Z",
    transform: "translate(-5341.71 -1865.297)",
    fill: "#fff",
    stroke: "#89532d",
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44340",
    "data-name": "Path 44340",
    d: "M.341-.051a2.6,2.6,0,0,1,.972-.214,3.567,3.567,0,0,1,1.076.214.377.377,0,0,1,.341.4.377.377,0,0,1-.341.4A4.216,4.216,0,0,0,1.314.581,3.057,3.057,0,0,0,.341.757.377.377,0,0,1,0,.353.377.377,0,0,1,.341-.051Z",
    transform: "translate(19.742 14.215)",
    fill: "#20110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44341",
    "data-name": "Path 44341",
    d: "M.341-.051a2.6,2.6,0,0,1,.972-.214,3.567,3.567,0,0,1,1.076.214.377.377,0,0,1,.341.4.377.377,0,0,1-.341.4A4.216,4.216,0,0,0,1.314.581,3.057,3.057,0,0,0,.341.757.377.377,0,0,1,0,.353.377.377,0,0,1,.341-.051Z",
    transform: "translate(13.871 14.215)",
    fill: "#20110c"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatar2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-2.4b49a147.svg";
export { ForwardRef as ReactComponent };